import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CancelSubscriptionApi, GetAllCategories, GetAllPackages, UpgradeSubscriptionApi } from '../../Redux/Auth/Auth_Action';
import { showLoader } from '../../Redux/services/Loader';
import '../../assets/css/subscribeopt.css';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PayPalView from '../../Components/UpgradeSubscription/Paypals/Paypal2';
import Venmo from '../../Components/UpgradeSubscription/venmos/Venmo2';
import StripeForm from '../../Components/UpgradeSubscription/Stripes/StripeForm2';
// import CashAppSubs from '../../Components/UpgradeSubscription/Cashapps/Cashapp2';

const SubscriptionOption = (props) => {
    const navigate = useNavigate();
    const reduxToken = useSelector((state) => state?.Auth.token);
    // dialog options
    const [open, setOpen] = React.useState(false);
    const [openModal, setOpenModal] = React.useState(false);
    const [openModal2, setOpenModal2] = React.useState(false);
    const [getDetails, setGetDetails] = useState(null);

    // interest work starts
    const [interests, setInterests] = useState({ interestsData: [] });
    const [postInterests, setPostInterests] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState("");
    const [paypalTrue, setPaypalTrue] = useState(false);
    const [sucesses, setSucesses] = useState("");
    // const [limitIntrst, setLimitIntrst] = useState();
    // interest work ends

    // interests function starts
    const IntrestFunction = () => {
        dispatch(GetAllCategories())
            .then((res) => {
                // console.log("GetAllCategories", res.data.response.data.data);
                setInterests({ ...interests, interestsData: res?.data?.response?.data?.data });
                showLoader("none");
            })
            .catch((e) => {
                console.log(e);
                showLoader("none");
                toast.error("Network Error");
            })
    }
    // zaam
    // console.log(getDetails?.limit_of_interest, 'zzzzzzzzzzzzzzzzzzzzzzzz');

    const SelectItem = (id) => {
        // getDetails.limit_intrst;
        // let limit = location.state.limit_intrst;
        if (postInterests?.length == getDetails?.limit_of_interest || postInterests?.length > getDetails?.limit_of_interest) {
            toast.error(`can select only ${getDetails?.limit_of_interest} packages`)
            setPostInterests([]);
        } else {
            if (postInterests?.includes(id) === false) {
                setPostInterests((oldVal) => {
                    return [...oldVal, id];
                });
            } else {
                setPostInterests((oldVal) => {
                    let filtarr = postInterests?.filter((item, index) => {
                        return item !== id;
                    })
                    return [...filtarr];
                })
            }
        }
    }
    // interest function ends


    const handleClickOpen = (item) => {
        setGetDetails(item);
        setOpen(true);
        setPostInterests([]);
    };

    const handleClickOpen2 = () => {
        setOpenModal(true);
    }

    const handleClose = () => {
        setPaymentMethod("")
        setPaypalTrue(false)
        setOpen(false);

    };

    const handleClose2 = () => {
        setOpenModal(false);
    };

    const handleClose22 = () => {
        setOpenModal2(false);
    };

    const UpgradeSubs = (e) => {
        e.preventDefault();
        let data = {
            slug: getDetails?.slug,
            interest: postInterests,
            payment_type: paymentMethod
        }
        dispatch(UpgradeSubscriptionApi(data, reduxToken))
            .then((res) => {
                // console.log('zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz', res.data.response.data);
                showLoader("none");
                if (res.data.message === "Package has been upgrade successfully!") {
                    toast.info("Package has been upgrade successfully!");
                    // setOpenModal2(true)
                    // navigate('/subscription');
                } else {
                    toast.info(res.data.message);
                }
            })
            .catch((e) => {
                console.log(e);
                showLoader("none");
            })
        // handleClose(false);
    }


    // dialog options
    const dispatch = useDispatch();
    const tokenFromRedux = useSelector((state) => state.Auth.token);
    const [packages, setPackages] = useState({ packageItems: [] });
    const [pagination, setPagination] = useState({ paginationData: [] })
    const reduxState = useSelector((state) => state);

    const PackagesGetAll = () => {
        dispatch(GetAllPackages(tokenFromRedux))
            .then((res) => {
                setPackages({ ...packages, packageItems: res?.data.data?.map(item => item).filter(item => item?.id != reduxState?.Auth?.activePackage?.package_id) })
                // console.log(res?.data?.links)
                setPagination({ ...pagination, paginationData: res?.data.links })
                showLoader("none");
            })
            .catch((e) => {
                console.log(e);
                showLoader("none");
                toast.error("Network Error");
            })
    }

    const CancelSubscription = () => {
        dispatch(CancelSubscriptionApi(tokenFromRedux))
            .then((res) => {
                // console.log(res);
                toast.success("Subscription has been canceled");
                showLoader("none");
                navigate('/');
            })
            .catch((e) => {
                console.log(e);
                showLoader("none");
                toast.error("Network Error");
            })
        setOpenModal(false);
    }

    useEffect(() => {
        PackagesGetAll();
        IntrestFunction();
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='SubscriptionOption'>
            <div className='row'>
                <div className='col-lg-12'>
                    <p className='f-pop-bold f-30'>UPDATE PACKAGE</p>
                    <p className='f-mon-bold f-25 clr-e0 ml-0 mt-4'>CHOOSE OPTIONS TO UPDATE SUBSCRIPTION</p>
                    {/* <p className='f-mon-semibold f-20 mb-0'>Package Includes</p> */}
                </div>
                <div>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Do you want to update subscription?"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText className='clr-e0' id="alert-dialog-description">
                                Your package amount will be adjusted from previous package , there will be no refund , additional charges on upgrading package will be automatically deducted from your acoount
                            </DialogContentText>
                            <h3 className='f-20 mt-3'>You can select upto {getDetails?.limit_of_interest} interests from following sports</h3>
                            {interests?.interestsData?.map((item, index) => {
                                return (
                                    <div key={index} className='intrest_div my-3'>
                                        <div className='row pr-4'>
                                            <div className='col-lg-8'>
                                                <span
                                                    className='clr-e0 f-mon-bold'>{item?.title}</span>
                                            </div>
                                            <div className='col-lg-4 text-right'>
                                                <input
                                                    type="checkbox"
                                                    checked={postInterests?.includes(item?.id)}
                                                    onChange={selected => SelectItem(item.id)}
                                                    className='mt-1 ml-3' />
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                            <div className='intrest_div my-3 mt-5'>
                                <h3 className='f-20 mt-3'>Payment Method</h3>
                                {/* <div className='row pr-4'>
                                    <div className='col-lg-8'>
                                        <span
                                            className='clr-e0 f-mon-bold'>Paypal</span>
                                    </div>
                                    <div className='col-lg-4 text-right'>
                                        <input
                                            type="checkbox"
                                            checked={paymentMethod === "paypal"}
                                            onChange={(e) => setPaymentMethod("paypal")}
                                            className='mt-1 ml-3' />
                                    </div>
                                </div> */}
                                {/* <div className='row pr-4'>
                                    <div className='col-lg-8'>
                                        <span
                                            className='clr-e0 f-mon-bold'>Venmo</span>
                                    </div>
                                    <div className='col-lg-4 text-right'>
                                        <input
                                            type="checkbox"
                                            checked={paymentMethod === "venmo"}
                                            onChange={(e) => setPaymentMethod("venmo")}
                                            className='mt-1 ml-3' />
                                    </div>
                                </div> */}
                                {/* <div className='row pr-4'>
                                    <div className='col-lg-8'>
                                        <span
                                            className='clr-e0 f-mon-bold'>Cash App</span>
                                    </div>
                                    <div className='col-lg-4 text-right'>
                                        <input
                                            type="checkbox"
                                            checked={paymentMethod === "cashapp"}
                                            onChange={(e) => setPaymentMethod("cashapp")}
                                            className='mt-1 ml-3' />
                                    </div>
                                </div> */}
                                <div className='row pr-4'>
                                    <div className='col-lg-8'>
                                        <span
                                            className='clr-e0 f-mon-bold'>Stripe</span>
                                    </div>
                                    <div className='col-lg-4 text-right'>
                                        <input
                                            type="checkbox"
                                            checked={paymentMethod === "stripe"}
                                            onChange={(e) => setPaymentMethod("stripe")}
                                            className='mt-1 ml-3' />
                                    </div>
                                </div>
                            </div>
                            <div className='intrest_div my-3 mt-5'>
                                {paymentMethod === "stripe"
                                    &&
                                    <StripeForm
                                        handleSet={{ price: getDetails?.price, slug: getDetails?.slug, interestsData: postInterests }}

                                    />
                                }
                                {/* {paymentMethod === "venmo"
                                    &&
                                    <Venmo props={{ price: getDetails?.price, slug: getDetails?.slug, interestsData: postInterests }} />
                                }
                                {paymentMethod === "paypal"
                                    &&
                                    <div className="ButtonPreviewsss">
                                        <button className="Paypal_btn" onClick={() => {
                                            setPaypalTrue(true)
                                        }}>Pay<span className="paypal_pal">Pal</span></button>
                                    </div>
                                } */}

                                {/* {
                                    paypalTrue === true &&
                                    <PayPalView props={{ price: getDetails?.price, slug: getDetails?.slug, interestsData: postInterests, href: "profilePage" }} />
                                } */}
                                {/* {paymentMethod === "cashapp"
                                    &&
                                    <CashAppSubs props={{ price: getDetails?.price, slug: getDetails?.slug, interestsData: postInterests }} />
                                } */}
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <button onClick={handleClose} className="bt-profile-pink mr-4">CLOSE</button>
                            {/* <button disabled={!postInterests[0] || !paymentMethod} onClick={UpgradeSubs} className="bt-profile-grn">UPDATE PACKAGE</button> */}
                        </DialogActions>
                    </Dialog>
                </div>
                <div>
                    <Dialog
                        open={openModal}
                        onClose={handleClose2}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Do you want to cancel subscription?"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText className='clr-e0' id="alert-dialog-description">
                                By cancel subscription your amount will not be refund , only recurring subscription will be halted
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <button onClick={handleClose2} className="bt-profile-pink ">DISAGREE</button>
                            <button onClick={CancelSubscription} className="bt-profile-grn ">CANCEL SUBSCRIPTION</button>
                        </DialogActions>
                    </Dialog>
                </div>

                <div className='col-lg-12'>
                    <div className='about_us packages subscribeopt'>
                        <div className='crd-flex'>
                            {packages?.packageItems?.map((item, index) => {
                                return (
                                    <div key={index}
                                        onClick={() => { handleClickOpen(item) }}
                                        className='card mx-2 rounded-0 border-0 crd-top-pos h-100'>
                                        <div className='card-body border-0 p-23rem crd-hover-bg tickchange p-white'>
                                            <div className='row'>
                                                <div className='col-lg-12'>
                                                    <p className='card-title mb-2'>{item?.title}</p>
                                                </div>
                                                <div
                                                    dangerouslySetInnerHTML={{ __html: item?.package_offer }}
                                                    className='col-lg-12 text-left dan'>
                                                </div>
                                                <div className='flx-bx-price'>
                                                    <div className='row'>
                                                        <div className='col-md-12'>
                                                            <div className='price-container'>
                                                                <p className='price mr-1 mb-0'>${item?.price}</p>
                                                                <p className='delete-price line_over ml-1'> {item?.old_price}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className='col-lg-6'>
                    <button onClick={() => { navigate("/subscription") }} className='bt-profile-grn mr-3 mt-3 ml-3'>BACK TO MY SUBSCRIPTION</button>
                </div>
                <div className='col-lg-6 text-right'>
                    <button onClick={setOpenModal} className='bt-profile-pink mr-3 mt-3'>CANCEL MEMBERSHIP</button>
                </div>
                {/* <div className='col-lg-12 mt-4'>
                    <div className='d-flex res-col'>
                        <button onClick={() => { props.changeOption(1) }} className='bt-profile-blu '>BACK</button>
                        <button className='bt-profile-grn '>UPDATE PACKAGE</button>
                        <button className='bt-profile-pink '>CANCEL MEMBERSHIP</button>
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default SubscriptionOption;